import React from 'react';
import ServiceFAQList from '@/components/services/ServiceFAQList';
import useServiceFAQs from '@/components/services/useServiceFAQs';
import { BUSINESS } from '@/lib/businessConfig';

export default function DynamicServiceFAQ({ path, sourceSlug, fallback, items }) {
  const { items: answers, loading, error } = useServiceFAQs({ path, sourceSlug, fallback, items });
  const english = path.startsWith('/en/');
  if (loading) return <p role="status" className="text-body text-muted py-6">{english ? 'Loading questions…' : 'Φόρτωση ερωτήσεων…'}</p>;
  if (!answers.length) return <p className="text-body text-muted py-6">{english ? 'For information about this service, please contact the atelier.' : 'Για πληροφορίες σχετικά με αυτή την υπηρεσία, επικοινωνήστε με το atelier.'}{error && <span role="alert">{english ? ' Questions could not be loaded.' : ' Δεν ήταν δυνατή η φόρτωση των ερωτήσεων.'}</span>}</p>;
  const schema = {
    '@context': 'https://schema.org', '@type': 'FAQPage',
    '@id': `${BUSINESS.siteUrl}${path}#service-faq`, url: `${BUSINESS.siteUrl}${path}`,
    inLanguage: english ? 'en-GB' : 'el-GR',
    mainEntity: answers.map(({ question, answer }) => ({
      '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  };
  return (
    <div id="service-faq" lang={english ? 'en' : 'el'} className="scroll-mt-28">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, '\\u003c') }} />
      <ServiceFAQList items={answers} />
    </div>
  );
}